import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import {
  developmentAreaOptions,
  landSubUseTypes,
  landUseZoneOptions,
  planOnOptions,
  plotSubUseOptions,
  plotUseOptions,
  ResidentialUseList,
  schemeNameList,
  subdevelopmentOptions,
  yesOrNo,
} from "../../../../TCPForms/data";
import { Col, Container, Row } from "react-bootstrap";

const SubStep3 = ({ formData, handleSubTabChange, isEmployee, isNocModule = false }) => {
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, watch, setValue, control } = useForm({ defaultValues });

  const watchRegistrationType = formData?.registrationType;
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  useEffect(() => {
    setValue("plotInfo.plotArea", formData?.plotArea);
    setValue("plotInfo.builtupArea", formData?.totalBuildUpArea);
  }, []);
  const onSubmit = (data) => {
    handleSubTabChange(2, data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Plot Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            {/* <Row>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={landUseZoneOptions}
                                    label={t("Land Use")}
                                    placeholder={t("Select Type of Land")}
                                    name="plotInfo.zoneType"
                                    defaultValue={formData?.typeofArea ||  formData?.plotInfo?.zoneType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                {watchlandUseType ? <InputWrapper
                                    control={control}
                                    data={ResidentialUseList}
                                    label={t("Land Sub Use")}
                                    placeholder={t("Select Type Land Subuse")}
                                    name="plotInfo.subZoneType"
                                    defaultValue={formData?.plotInfo?.subZoneType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                /> : <InputWrapper
                                    control={control}
                                    data={landSubUseTypes}
                                    label={t("Land Sub Use")}
                                    placeholder={t("Select Type of Land Subuse")}
                                    name="plotInfo.subZoneType"
                                    defaultValue={formData?.plotInfo?.subZoneType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />}
                            </Col>

                        </Row>

                        <Row>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={plotUseOptions}
                                    label={t("Plot Use")}
                                    placeholder={t("Select Type of Plot Use")}
                                    name="plotInfo.plotType"
                                    defaultValue={formData?.plotInfo?.plotType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={plotSubUseOptions}
                                    label={t("Plot Sub Use")}
                                    placeholder={t("Select Type of Plot Sub Use")}
                                    name="plotInfo.plotSubType"
                                    defaultValue={formData?.plotInfo?.plotSubType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={developmentAreaOptions}
                                    label={t("Development Area")}
                                    placeholder={t("Select Development Area")}
                                    name="plotInfo.developmentArea"
                                    defaultValue={formData?.plotInfo?.developmentArea}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={subdevelopmentOptions}
                                    label={t("Sub Development Area")}
                                    placeholder={t("Sub Development Area")}
                                    name="plotInfo.subdevelopmentType"
                                    defaultValue={formData?.plotInfo?.subdevelopmentType}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                        </Row> */}

            {/* <Row>
                            <Col>
                                <InputWrapper
                                    control={control}
                                    data={planOnOptions}
                                    label={t("Plan On")}
                                    placeholder={t("Select Plan On")}
                                    name="plotInfo.planOn"
                                    defaultValue={formData?.plotInfo?.planOn}
                                    type="selectInput"
                                    mandatory
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        }
                                    }}
                                />
                            </Col>
                            <Col>
                                <InputWrapper
                                    label="Scheme Name"
                                    control={control}
                                    placeholder="Select Scheme Name"
                                    name={`plotInfo.schemeName`}
                                    defaultValue={formData?.plotInfo?.schemeName}
                                    type="selectInput"
                                    mandatory
                                    data={schemeNameList}
                                    validation={{
                                        required: {
                                            value: true,
                                            message: "This field is required"
                                        },
                                    }}
                                />
                            </Col>
                        </Row> */}

            <Row>
              <Col>
                <InputWrapper
                  label={t("Plot Area (sq.mtr)")}
                  control={control}
                  placeholder={t("Enter Plot Area")}
                  name="descriptionOfLand.landArea"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.descriptionOfLand?.landArea}
                  type="textInput"
                  disabled={formData?.plotArea || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {" "}
                <InputWrapper
                  label={t("Sanctioned Built up Area (sq.mtr)")}
                  control={control}
                  placeholder={t("Enter Sanctioned Built up Area")}
                  name="totalBuildUpArea"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.totalBuildUpArea || formData?.plotInfo?.builtupArea}
                  type="textInput"
                  disabled={formData?.totalBuildUpArea || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>

              {/* <Col>
                <InputWrapper
                  label={t("Sanctioned Built up Area (sq.mtr)")}
                  control={control}
                  placeholder={t("Enter Sanctioned Area")}
                  name="sanctionBuiltupArea"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.sanctionBuiltupArea}
                  type="textInput"
                  // disabled={formData?.sanctionBuiltupArea || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}
            </Row>
            <Row>
              {/* <Col><InputWrapper
                                label={t("Circle Rate")}
                                control={control}
                                placeholder={t("Enter Circle Rate")}
                                name="plotInfo.criticalRate"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.criticalRate}
                                type="textInput"
                            /></Col> */}
              <Col>
                <InputWrapper
                  label={t("Estimated Cost (INR)")}
                  control={control}
                  placeholder={t("Enter Estimated Cost")}
                  name="plotInfo.estimatedCost"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.plotInfo?.estimatedCost}
                  disabled={isEmployee}
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col></Col>
            </Row>
            {/* <Row>
                            <Col><InputWrapper
                                label={t("Existing Built Up Area (Sq. Mtr.)")}
                                control={control}
                                placeholder={t("Enter Existing Built Up Area (Sq. Mtr.)")}
                                name="plotInfo.exsistingbuiltupArea"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.exsistingbuiltupArea}
                                type="textInput"
                            />
                            </Col>
                            <Col>
                                <InputWrapper
                                    label={t("Carpet Area")}
                                    control={control}
                                    placeholder={t("Enter Carpet Area")}
                                    name="plotInfo.carpetArea"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.plotInfo?.carpetArea}
                                    type="textInput"
                                />
                            </Col>
                        </Row> */}
            {/* <Row>
                            <Col>
                                <InputWrapper
                                    label={t("Estimated Cost")}
                                    control={control}
                                    placeholder={t("Enter Estimated Cost")}
                                    name="plotInfo.estimatedCost"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.plotInfo?.estimatedCost}
                                    type="textInput"
                                />
                            </Col>
                            <Col><InputWrapper
                                label={t("Groud Coverage Area")}
                                control={control}
                                placeholder={t("Enter Groud Coverage Area (Sq. Mtr.)")}
                                name="plotInfo.groundCoverageArea"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.maximumPermissibleGroundCoverage || formData?.plotInfo?.groundCoverageArea}
                                type="textInput"
                            /></Col>
                        </Row>
                        <Row>
                            <Col>  <InputWrapper
                                control={control}
                                data={yesOrNo}
                                label={t("If Community Parking Provided")}
                                placeholder={t("Select Community Parking")}
                                name="plotInfo.communityParking"
                                defaultValue={formData?.plotInfo?.communityParking}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            /></Col>
                            <Col> <InputWrapper
                                label={t("Number of Stories including Ground Floor")}
                                control={control}
                                placeholder={t("Enter Number of Stories")}
                                name="plotInfo.noOfStories"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.noOfStories}
                                type="textInput"
                            />
                            </Col>
                        </Row> */}
            {/* <Row>
                            <Col><InputWrapper
                                control={control}
                                data={yesOrNo}
                                label={t("Additional FAR against TDR")}
                                placeholder={t("Additional FAR against TDR")}
                                name="plotInfo.isAdditionalFAR"
                                defaultValue={formData?.plotInfo?.isAdditionalFAR}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                            <Col><InputWrapper
                                control={control}
                                data={yesOrNo}
                                label={t("Is this Approved Layout")}
                                name="plotInfo.approvedLayout"
                                defaultValue={formData?.plotInfo?.approvedLayout}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                        </Row> */}
            {/* <Row>
                            <Col><InputWrapper
                                label={t("Ground Coverage %")}
                                control={control}
                                placeholder={t("Ground Coverage %")}
                                name="plotInfo.groundCoverage"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.groundCoverage}
                                type="textInput"
                            />
                            </Col>
                            <Col> <InputWrapper
                                label={t("FAR")}
                                control={control}
                                placeholder={t("FAR")}
                                name="plotInfo.far"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.far}
                                type="textInput"
                            /></Col>
                        </Row>
                        <Row>
                            <Col>
                            <InputWrapper
                                control={control}
                                data={yesOrNo}
                                label={t("Is plot has special required value of Setback?")}
                                name="plotInfo.setback.required"
                                defaultValue={formData?.plotInfo?.setback?.required}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                            <Col>
                            <InputWrapper
                                label={t("Setback Front")}
                                control={control}
                                placeholder={t("Setback Front")}
                                name="plotInfo.setback.front"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.setback?.front}
                                type="textInput"
                            />
                            </Col>
                        </Row>
                        <Row>
                            <Col><InputWrapper
                                label={t("Setback Rear")}
                                control={control}
                                placeholder={t("Setback Rear")}
                                name="plotInfo.setback.rear"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.setback?.rear}
                                type="textInput"
                            />
                            </Col>
                            <Col><InputWrapper
                                label={t("Setback Side1")}
                                control={control}
                                placeholder={t("Setback Side1")}
                                name="plotInfo.setback.side1"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.setback?.side1}
                                type="textInput"
                            />
                            </Col>
                        </Row>
                        <Row>
                            <Col><InputWrapper
                                label={t("Setback Side2")}
                                control={control}
                                placeholder={t("Setback Side2")}
                                name="plotInfo.setback.side2"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.plotInfo?.setback?.side2}
                                type="textInput"
                            />
                            </Col>
                            <Col></Col>
                        </Row> */}

            <Row>
              {/* <Col>
                                <InputWrapper
                                    label={t("Sector Number")}
                                    control={control}
                                    placeholder={t("Enter Sector Number")}
                                    name="plotInfo.sectorNo"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.plotInfo?.sectorNo}
                                    type="textInput"
                                />
                            </Col> */}
              {/* <Col>
                                <InputWrapper
                                    label={t("Maximum Building Height")}
                                    control={control}
                                    placeholder={t("Enter Building Height")}
                                    name="plotInfo.maxBuildingHeight"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.plotInfo?.maxBuildingHeight}
                                    type="textInput"
                                />
                            </Col>
                            <Col><InputWrapper
                                label={t("Existing Built Up Area (Sq. Mtr.)")}
                                control={control}
                                placeholder={t("Enter Existing Built Up Area (Sq. Mtr.)")}
                                name="plotInfo.exsistingbuiltupArea"
                                mandatory
                                maxLength={15}
                                defaultValue={formData?.totalExistingBuiltUpArea || formData?.plotInfo?.exsistingbuiltupArea}
                                type="textInput"
                            /></Col> */}
            </Row>
          </Container>
        </div>
        {!isEmployee && !isNocModule && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(0)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep3;
